import * as React from 'react';
import { Path, Circle } from 'react-native-svg';

function Eyes() {
  return (
    <>
      <Path
        d="M31.48 67.46a26.29 26.29 0 014.53-13 43.31 43.31 0 0110.36-9.27 54.29 54.29 0 016-3.4c1-.5 2.09-1 3.16-1.41s2.19-.85 3.33-1.15a35.82 35.82 0 016.87-1.34 39.71 39.71 0 017-.13 44.4 44.4 0 016.89.93 47.83 47.83 0 016.67 1.88 48.67 48.67 0 016.38 2.78 36.81 36.81 0 015.85 3.87 35.49 35.49 0 019 10.72 25.63 25.63 0 011.94 13.64 27.57 27.57 0 00-4.61-12.21 31.77 31.77 0 00-8.2-9.82 37.82 37.82 0 00-11.34-6.15A44.19 44.19 0 0079 41.62a42.71 42.71 0 00-6.45-.87 38 38 0 00-6.49.12 33 33 0 00-6.33 1.24 32.07 32.07 0 00-3 1c-1 .42-2 .85-3 1.34A49.84 49.84 0 0048 47.71a40.53 40.53 0 00-9.66 8.6 28.85 28.85 0 00-6.86 11.15z"
        fill="#69b32d"
      />
      <Path
        d="M46.71 46a12.6 12.6 0 01-3.34-3.49 4.3 4.3 0 010-4.59 9.73 9.73 0 012.7-2 3.14 3.14 0 001.72-2.68c-.1-1.24-1.51-2.02-2.79-2.09s-2.55.33-3.84.37a3.21 3.21 0 01-3.22-1.64c-.52-1.32.49-2.8 1.71-3.53s2.68-1 3.92-1.7a6.6 6.6 0 002.93-7.47 6.74 6.74 0 00-6.62-4.59A4.46 4.46 0 0037 13.74a3.94 3.94 0 00-.91 3.78 5.79 5.79 0 002.41 3.18 7.64 7.64 0 007.66.39"
        fill="none"
        stroke="#69b32d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.44}
      />
      <Circle
        cx={40.94}
        cy={16.45}
        r={5.36}
        fill="#fff"
        stroke="#69b32d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.44}
      />
      <Circle cx={42.87} cy={17.63} r={2.47} fill="#09090a" />
      <Path
        d="M90.47 44.5a12.75 12.75 0 003.42-3.41A4.3 4.3 0 0094 36.5a9.68 9.68 0 00-2.65-2 3.15 3.15 0 01-1.67-2.72c.16-1.28 1.58-2 2.87-2.09s2.54.39 3.82.46 2.77-.37 3.26-1.56S99.18 25.74 98 25s-2.65-1.06-3.87-1.79a6.6 6.6 0 01-2.77-7.54 6.75 6.75 0 016.72-4.44 4.48 4.48 0 012.9 1.22 3.93 3.93 0 01.82 3.8 5.75 5.75 0 01-2.48 3.12 7.63 7.63 0 01-7.67.22"
        fill="none"
        stroke="#69b32d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.44}
      />
      <Circle
        cx={96.9}
        cy={15.06}
        r={5.36}
        fill="#fff"
        stroke="#69b32d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.44}
      />
      <Circle cx={94.95} cy={16.19} r={2.47} fill="#09090a" />
    </>
  );
}

export default Eyes;
